import { Button, Flex, InputNumber, Modal } from 'antd';

import { useEditProductItemSalePriceModal } from '@app/components/Modals/EditProductItemSalePriceModal/hooks';
import { InfoRow } from '@app/components/Modals/EditProductItemSalePriceModal/ui/InfoRow';
import { formatAmount } from '@app/shared/utils/formatAmount';

import type { FC } from 'react';

import '@app/components/Modals/EditProductItemSalePriceModal/styles/EditProductItemSalePriceModal.desktop.scss';

export interface EditProductItemSalePriceModalProps {
  open: boolean;
  productItemId: number;
  productName?: string | null;
  warehouseName?: string | null;
  currentSalePrice?: number | null;
  onClose(): void;
  afterSave?(): void;
}

export const EditProductItemSalePriceModal: FC<
  EditProductItemSalePriceModalProps
> = (props) => {
  const { open, productName, warehouseName, currentSalePrice, onClose } = props;
  const { salePrice, setSalePrice, isSaving, saveHandler, canSubmit } =
    useEditProductItemSalePriceModal(props);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Изменение цены продажи"
      destroyOnHidden
      className="EditProductItemSalePriceModal"
      footer={
        <Flex
          className="EditProductItemSalePriceModal__footer"
          justify="space-between"
          align="center"
        >
          <Button onClick={onClose} disabled={isSaving}>
            Отменить
          </Button>

          <Button
            type="primary"
            onClick={saveHandler}
            loading={isSaving}
            disabled={!canSubmit}
          >
            Сохранить
          </Button>
        </Flex>
      }
    >
      <div className="EditProductItemSalePriceModal__content">
        <div className="EditProductItemSalePriceModal__rows">
          <InfoRow label="Товар:" value={productName ?? '—'} />
          <InfoRow label="Склад:" value={warehouseName ?? '—'} />
          <InfoRow
            label="Текущая цена продажи:"
            value={formatAmount(currentSalePrice)}
          />

          <Flex
            className="EditProductItemSalePriceModal__row"
            align="center"
            justify="space-between"
            gap={16}
          >
            <div className="EditProductItemSalePriceModal__rowLabel">
              Новая цена продажи:
            </div>

            <div className="EditProductItemSalePriceModal__rowValue">
              <InputNumber
                className="EditProductItemSalePriceModal__priceInput"
                min={0}
                step={1}
                precision={2}
                value={salePrice}
                onChange={setSalePrice}
                disabled={isSaving}
                controls
              />
            </div>
          </Flex>
        </div>
      </div>
    </Modal>
  );
};
